import React from 'react';
import { object, string } from 'prop-types';
import { FormattedHTMLMessage } from 'react-intl';

const QuestionText = ({ textId, values }) => (
  <div className="followup__question-text">
    <FormattedHTMLMessage
      id={textId}
      values={values}
    />
  </div>
);

QuestionText.propTypes = {
  textId: string,
  values: object,
};

export default QuestionText;
